import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateTimeService } from '@uigy/shared/services/date-time/date-time.service';
import { DatesFormatsEnum } from '@uigy/shared/enums/dateFormats.enum';
import { ConfigService } from '@uigy/shared/services/config.service';
import { LicenseDetailsWithUsage, LicenseManagerService } from '@uigy/modules/license/license-manager.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import Utils from '@uigy/utils';

interface LicenseDetails {
  islimited?: boolean;
  expires: string;
  assetsUsage: string;
}

@Component({
    selector: 'app-nav-license',
    templateUrl: './nav-license.component.html',
    styleUrls: ['./nav-license.component.scss'],
    standalone: false
})
export class NavLicenseComponent {
  public navbarLicenseTexts = this.languageService.texts.navbar_license;
  public version$: Observable<string> = this.configService.getVersion();

  public licenseDetails$: Observable<LicenseDetails> = this.licenseManagerService.getLicenseDetails().pipe(
    Utils.filterNullsOperator(),
    map(license => ({
      islimited: (license as LicenseDetailsWithUsage).assetCountThreshold > 0,
      expires: DateTimeService.utcToLocalFormatted(license.expirationDate, DatesFormatsEnum.regularDate),
      assetsUsage: Math.floor((license as LicenseDetailsWithUsage).assetsUsage * 100) + '%'
    }))
  );

  constructor(
    private languageService: LanguageService,
    private configService: ConfigService,
    private licenseManagerService: LicenseManagerService,
  ) { }
}
